import { combineReducers } from 'redux';
import reducer from './reducer';

function lastAction(state = null, action: any) {
    return action;
}

export const rootReducer = combineReducers({reducer, lastAction});

export type RootState = ReturnType<typeof rootReducer>;